import script from "./footerView.vue?vue&type=script&setup=true&lang=js"
export * from "./footerView.vue?vue&type=script&setup=true&lang=js"

import "./footerView.vue?vue&type=style&index=0&id=bb02e688&lang=scss&scoped=true"

import exportComponent from "D:\\openAi\\chinese-academy-of-sciences-home\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb02e688"]])

export default __exports__